const check = (object) => object === null || object === undefined ? true : Object.entries(object).length === 0 ? true : false;
export const isEmptyObject = (object) => typeof object === 'number' ? check(String(object)) : check(object)